"use strict";
// (C) 2021-2022 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.LabelFormatControl = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var react_intl_1 = require("react-intl");
var DropdownControl_1 = tslib_1.__importDefault(require("../DropdownControl"));
var translations_1 = require("../../../utils/translations");
var dropdowns_1 = require("../../../constants/dropdowns");
var locales_1 = require("../../../../locales");
var getControlProperties = function (properties, axis) {
    var _a, _b, _c, _d;
    var axisProperties = (_a = properties === null || properties === void 0 ? void 0 : properties.controls) === null || _a === void 0 ? void 0 : _a[axis];
    var axisVisible = (_b = axisProperties === null || axisProperties === void 0 ? void 0 : axisProperties.visible) !== null && _b !== void 0 ? _b : true;
    var axisLabelsEnabled = (_c = axisProperties === null || axisProperties === void 0 ? void 0 : axisProperties.labelsEnabled) !== null && _c !== void 0 ? _c : true;
    var axisFormat = (_d = axisProperties === null || axisProperties === void 0 ? void 0 : axisProperties.format) !== null && _d !== void 0 ? _d : "auto";
    return {
        axisVisible: axisVisible,
        axisLabelsEnabled: axisLabelsEnabled,
        axisFormat: axisFormat,
    };
};
var LabelFormatControlComponent = function (props) {
    var disabled = props.disabled, properties = props.properties, axis = props.axis, configPanelDisabled = props.configPanelDisabled, pushData = props.pushData, intl = props.intl;
    var _a = getControlProperties(properties, axis), axisVisible = _a.axisVisible, axisLabelsEnabled = _a.axisLabelsEnabled, axisFormat = _a.axisFormat;
    var isDisabled = disabled || !axisVisible || !axisLabelsEnabled;
    return (react_1.default.createElement(DropdownControl_1.default, { value: axisFormat, valuePath: axis + ".format", labelText: locales_1.messages.axisFormat.id, disabled: isDisabled, showDisabledMessage: !configPanelDisabled && isDisabled, properties: properties, pushData: pushData, items: translations_1.getTranslatedDropdownItems(dropdowns_1.formatDropdownItems, intl) }));
};
exports.LabelFormatControl = react_intl_1.injectIntl(LabelFormatControlComponent);
//# sourceMappingURL=LabelFormatControl.js.map